<template>
    <div class="animated fadeIn requirements--requirements-list h-100">
        <div class="card-body d-flex flex-column">
            <dl>
                <dt>Sales Person: </dt>
                <dd> {{ user.name }}</dd>
            </dl>
            <grid-component
                isResizable
                isReorderable
                :gridId="requirementGridId"
                :itemData="checkedRowItemIdsObjArr"
                :fields="requirementFields"
            />
            <p class="mt-4">Select from your open RFP's to add the selected requirement(s), or create a new RFP</p>
            <grid-component
                isResizable
                isReorderable
                :gridId="gridId"
                :itemData="itemData"
                :fields="rfpFields"
                :handleRowClick="onRowClicked"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GridSettings from '@/shared/components/GridSettings';
import { prepareColumnsData } from '@/shared/helpers';
import { date,dateTime } from '@/shared/filters';
import requirementFields from './requirementFields';
import rfpFields from './rfpFields';
import GridComponent from '@/shared/components/GridComponent';
import { GRID_ID } from '@/shared/constants';

export default {
    components: {
        GridComponent
    },
    props: {
        rfpItems: {
            type: Array,
            default: () => [],
        },
        checkedRowItemIdsObjArr: {
            type: Array,
            default: () => []
        },
        onRowClick: [Function],
    },
    data: () => ({
        requirementFields,
        rfpFields,
        prepareColumnsData,
        selectedRowItemId: 0,
        date,
        dateTime,
        requirementGridId:GRID_ID.REQUIREMENT_CREATE_RFP,
        gridId:GRID_ID.RFP
    }),
    computed: {
        ...mapGetters('rfps', ['openRfpsBySalesPerson']),
        ...mapGetters('account', ['gridSettingsById']),
        ...mapState('account', ['user']),
        gridSettings() {
            return this.gridSettingsById(this.gridId);
        },
        itemData() {
            console.log(this.openRfpsBySalesPerson, 'OPEN RFP')
            return this.openRfpsBySalesPerson.map((item) => ({ ...item, selected: item.id === this.selectedRowItemId }));
        },
    },
    methods: {
        onRowClicked(e) {
            this.selectedRowItemId = e.dataItem.id;
            this.onRowClick(e);
        },
    }
}
</script>
<style scoped>
dt { float: left; clear: left; width: 7em; font-weight: bold; font-size: medium }
dd { float: left; font-size: medium }
</style>